import { render, staticRenderFns } from "./ParentingAgreements.vue?vue&type=template&id=758a2cd1"
import script from "./ParentingAgreements.vue?vue&type=script&lang=js"
export * from "./ParentingAgreements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports